import {
  COMPANY_VALUE_FIRST_CHAR,
  EMOJI_FIRST_CHAR
} from "../constants"

const ALLOWED_FIRST_CHARS = [COMPANY_VALUE_FIRST_CHAR, EMOJI_FIRST_CHAR]

const currentWordFromPhrase = ({cursorPosition, phrase}) => {
  const preCursorText = phrase.substring(0, cursorPosition)
  const phraseArray = preCursorText.split(/\s+/)
  const lastWord = phraseArray[phraseArray.length - 1]

  return {
    startOfWordCursorPosition: (preCursorText.length - lastWord.length),
    word: lastWord
  }
}

const currentWordStartsWith = (props = {}) => {
  const {
    cursorPosition,
    firstChar = EMOJI_FIRST_CHAR,
    phrase = null
  } = props

  if (!phrase) { return null }
  if (!ALLOWED_FIRST_CHARS.includes(firstChar)) { return null }

  const minWordLength = firstChar === EMOJI_FIRST_CHAR ? 2 : 1
  const {startOfWordCursorPosition, word} = currentWordFromPhrase({cursorPosition, phrase})

  if (!word) { return null }

  if (word.length < minWordLength) { return null }
  if (word.charAt(0) !== firstChar) { return null }

  const replaceRegex = new RegExp(`${firstChar}`, "g")
  return {
    endOfWordCursorPosition: startOfWordCursorPosition + word.length,
    fullString: word,
    reducedString: word.replace(replaceRegex, ""),
    startOfWordCursorPosition
  }
}

export default currentWordStartsWith
